import React from 'react';
import './camera.css';

const Camera = () => {
  	return (
  		<div className="upload">
  			<div className="upload-text">
  				<strong>Upload files </strong>
  				 <p> or snap a picture!</p> 
  			</div>
  		</div>





  	);
};

export default Camera;




// WEBPACK FOOTER //
// ./src/components/Camera/index.js